import React from 'react';
import FlashOnIcon from '@material-ui/icons/FlashOn';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AirportShuttleIcon from '@material-ui/icons/AirportShuttle';
import { Typography } from "@material-ui/core";

const formatCurrency = (amount, currency = "$") => {
    return `${currency}${amount.toLocaleString("en-US")}`;
};

const PolicyDisplayCard = ({ title, totalAmount, userAmount, bankAmount }) => {
    return (
            <div className="policy-card">
                <Typography variant="caption" className="policy-title">{title}</Typography>
                <div className="policy-main-content">

                    {/* Left Section: User Contribution */}
                    <div className="policy-section">

                        <div className="connector">
                            <FlashOnIcon className="bolt-icon"  style={{color:"#ff4d9a"}} />
                        </div>
                        <AccountCircleIcon className="icon user-icon " style={{color:"#ff4d9a"}} />
                        <div className="amount">{formatCurrency(userAmount)}</div>
                        <div className="label">Total From You</div>
                    </div>

                    {/* Center Section: Total Dial */}
                    <div className="policy-dial">
                        <div className="dial-inner">
                            <AirportShuttleIcon className="icon car-icon"   />
                            <div className="total-amount">{formatCurrency(totalAmount)}</div>
                            <div className="total-label">Total Paid to Policy</div>
                        </div>
                    </div>

                    {/* Right Section: Bank Contribution */}
                    <div className="policy-section">

                        <div className="connector right">
                            <FlashOnIcon className="bolt-icon" style={{color:"#ffc94d"}}/>
                        </div>
                        <AccountBalanceIcon className="icon bank-icon" style={{color:"#ffc94d"}}/>
                        <div className="amount">{formatCurrency(bankAmount)}</div>
                        <div className="label">Total From Bank</div>
                    </div>

                </div>
            </div>
    );
};

export default PolicyDisplayCard;